const config = {
  search: '/catalog/search',
};

export default config;
